import React from "react";

const FrontendFooter = () => {
  return (
    <footer
      style={{ backgroundColor: "#9642bc", height: "80px", padding: "30px" }}
    >
      <div className="container ">
        <div className="row">
          <div className="col-md-6 text-left">
            <div className="copyright-text text-white">
              <h6 className="mb-0">
                SCHOOL OF OPEN LEARNING (SOL)
              </h6>
            </div>
          </div>

          <div className="col-md-6 text-end">
            <div className="copyright-text text-white">
              <h6 className="mb-0">
               &copy; {new Date().getFullYear()}  Powered by Open Learning Development Centre (OLDC)
              </h6>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FrontendFooter;
